<template>
    <div class="search-skeleton-wrapper" :class="{'side-margin':!isSearch}">
        <div class="search-skeleton-content">
            <div class="loading-120">
                <skeleton-loader :size="16"/>
            </div>
            <div class="loading-220">
                <skeleton-loader :size="16"/>
            </div>
        </div>
        <div class="search-skeleton-content">
            <div class="loading-180">
                <skeleton-loader :size="14"/>
            </div>
            <div class="loading-100">
                <skeleton-loader :size="14"/>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>

import { SkeletonLoader } from '@bookingkit/coppi';
import { defineProps, withDefaults } from 'vue';

interface SettingsProps {
    isSearch: boolean,
}

withDefaults(defineProps<SettingsProps>(), {
    isSearch: false,
});

</script>
<style scoped>
.side-margin {
  margin: 0 var(--s6);
}

.loading-120 {
  width: 120px;
  margin-top: var(--s2);
}

.loading-180 {
  width: 180px;
  margin-top: var(--s2);
}

.loading-220 {
  width: 220px;
  margin-top: var(--s2);
}

.loading-100 {
  width: 100px;
  margin-top: var(--s2);
}

.search-skeleton-wrapper {
  padding: var(--s3) 0 var(--s1) 0;
}

@media screen and (min-width: 769px) {
  .search-skeleton-content {
    display: flex;
    justify-content: space-between;
  }
}
</style>
